import React from "react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative py-16 border-t border-[#EAF0F6] bg-[#F7F9FC]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <p className="font-hand text-4xl text-[#7B9ACC] leading-tight">
            here's to Saloni —
          </p>
          <p className="mt-3 font-body text-[#334E68] max-w-md">
            Bob, Onnii, Mumma to Via, Perk's person, Pista's favourite target —
            coffee reheater, pani puri champion, softy loyalist, and the softest
            heart in the loudest room. This little site is a hug. Wear it well.
          </p>
        </div>
        <div className="md:text-right">
          <p className="font-body text-xs uppercase tracking-[0.35em] text-[#7B9ACC]">
            Made with 💙 by the family
          </p>
          <p className="mt-2 font-display font-bold text-2xl text-[#0B192C] tracking-tight">
            One Saloni, endless love.
          </p>
        </div>
      </div>
    </footer>
  );
}
